<template>
  <div class="wrapper col-8">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-edit"></i> MoFA - No Strike List          
        </div>
          <!-- BEGIN MOFA FORM -->
            <b-form id="mofa">
              <b-container class="table text-right">
                <b-row>
                  <b-col sm="12">
                    <b-form>
                        <b-row>
                          <b-col sm="6">
                            <b-form-group description="Name of the Agency/Organization">
                              <label for="agency">المنظمة /الدولة</label>                              
                              <b-form-select v-model="agencyId" 
                                   type="text" placeholder="Participant Agency" 
                                   text-field="name" 
                                   value-field="id" 
                                   :options="agencyList"> 
                              </b-form-select>
                              <b-button class="mt-2" size="sm" variant="primary" v-b-modal.agencyModal v-b-modal.modal-center> <i class="fa fa-plus"></i> أضف وكالة </b-button>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col> <hr/> </b-col>
                        </b-row>

                        <b-row>
                          <b-col sm="4"> 
                            <b-form-group description="Travel Date" class="required" :class="{error: validation.hasError('travelDate')}">
                              <label for="travelDate">تاريخ الرحلة</label><br>
                              <datepicker format="DD/MM/YYYY" v-model="travelDate" :local="local"/>
                            </b-form-group>
                          </b-col>                         
                        </b-row>

                        <b-row>
                          <b-col>                               
                              <hr/>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col sm="4"> 
                            <b-form-group description="Request Type">
                              <label for="requestTypeId">وسيلة النقل</label>
                              <b-form-input type="text" value="No Strike List" id="requestTypeId" disabled></b-form-input> 
                            </b-form-group>
                          </b-col>
                          <b-col sm="6"> 
                            <b-form-group description="Vehicle Type" class="required" :class="{error: validation.hasError('vehicleType')}">
                              <label for="vehicleType">النوع من المركبات</label>
                              <b-form-textarea id="vehicleType"
                                v-model="vehicleType"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row> 

                        <b-row>
                          <b-col> <hr/> </b-col>
                        </b-row> 

                        <b-row>
                          <b-col sm="4"> 
                            <b-form-group description="Route">
                              <label for="route">مسار الرحلة</label>
                              <b-form-textarea id="route"
                                v-model="route"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>                          
                          <b-col sm="4"> 
                            <b-form-group description="Cargo Details">
                              <label for="cargoDetails">تفاصيل الحمولة</label>
                              <b-form-textarea id="cargoDetails"
                                v-model="cargoDetails"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>
                          <b-col sm="4"> 
                            <b-form-group description="Cargo Type">
                              <label for="cargoType">محتواها</label>
                              <b-form-textarea id="cargoType"
                                v-model="cargoType"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col> <hr/><label>مخطط استفادة من الحمولة بعد التفريغ في اليمن </label>
                          </b-col>
                        </b-row>

                         <b-row>
                          <b-col sm="4"> 
                            <b-form-group description="Distribution Plan">
                              <label for="transport">المحافظات والمديريات المستفيدة</label>
                              <b-form-textarea id="distributionPlan"
                                v-model="distributionPlan"
                                 placeholder=""
                                 :rows="3"
                                 :max-rows="6">
                              </b-form-textarea>
                            </b-form-group>
                          </b-col>
                          <b-col sm="4"> 
                            <b-form-group description="Primary Beneficiaries">
                              <label for="primaryBeneficiaries">الجهة اولية المستفيدة </label>
                                <b-form-textarea id="primaryBeneficiaries"
                                  v-model="primaryBeneficiaries"
                                   placeholder=""
                                   :rows="3"
                                   :max-rows="6">
                                </b-form-textarea>
                            </b-form-group>
                          </b-col>
                          <b-col sm="4"> 
                            <b-form-group description="Beneficiaries">
                              <label for="beneficiaries">الجهات الفرعية المستفيدة</label>
                                <b-form-textarea id="beneficiaries"
                                    v-model="beneficiaries"
                                     placeholder=""
                                     :rows="3"
                                     :max-rows="6">
                                </b-form-textarea>     
                              </b-form-group>
                          </b-col>
                        </b-row> 

                        <b-row>
                          <b-col> <hr/>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col sm="6"> 
                            <label for="route">:Please upload the following documents</label>
                            <ul>
                              <li>Updated Permanent Notified Site List</li>                              
                            </ul>
                            <b-form-group>
                                <file-upload
                                  ref='filename'                                 
                                  @event-handler="attachEventHandler($event)">
                                </file-upload>              
                            </b-form-group>
                          </b-col> 
                        </b-row>
                      
                    </b-form>        
                  </b-col>
                </b-row>
                <br><br>
              </b-container>
              <div slot="footer">
                  <b-button size="sm" variant="primary" @click="saveMofaEventHandler"> <i class="fa fa-save"></i> حفظ</b-button>&nbsp;
                  <b-button size="sm" variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> إغلاق</b-button>
              </div>
          </b-form>
          <!-- END MOFA FORM -->
      </b-card>
    </div>

    <!-- ADD AGENCY -->
    <b-modal ref="agencyModal" centered title="Add Agency" class="modal-primary" id="agencyModal" @shown="initModal">
      <b-row>        
        <b-col sm="12">          
          <b-form>
              <b-row>
                <b-col>
                  <b-form-group class="required" :class="{error: validation.hasError('agencyName')}">
                      <label>Agency Name</label>
                      <b-form-input ref="agencyName" id="agencyName" type="text" v-model="agencyName" placeholder="Enter agency name"></b-form-input>                    
                      <small ref="agencyNameError" class="text-muted">{{ validation.firstError('agencyName') }}</small>                      
                  </b-form-group>
                </b-col>
              </b-row>
          </b-form>
        </b-col>
      </b-row>
      <div slot="modal-footer">
         <b-button size="sm" variant="secondary" @click="cancelAgencyEventHandler"> <i class="fa fa-times"></i> إغلاق</b-button>
         <b-button size="sm" variant="primary" @click="saveAgencyEventHandler"> <i class="fa fa-check"></i> يضاف </b-button>&nbsp;
      </div>
    </b-modal>  
    <!-- ADD AGENCY -->

    <!-- UPLOAD -->
    <b-modal hide-footer id="uploadModal" ref="uploadModal" title="Upload Photos">
      <b-form>
        <file-upload
                ref='filename'
                title="Please upload vehicle photos"
                @event-handler="attachEventHandler($event)">            
        </file-upload> 
        <div slot="footer" class="modal-footer">
          <b-button size="md" variant="primary" class="float-right modal-default-button" @click="validationModals('uploadPhotos')">Add</b-button>
          <b-button size="md" variant="secondary" class="float-right modal-default-button" @click="close('upload')">Close</b-button>
        </div>
      </b-form>
    </b-modal>
    <!--// ADD AGENCY -->

  </div>
</template>

<script>
import * as constants from '@/store/constants'
import * as types from '@/store/types'

import CommonService from '@/api/CommonService'
import MofaService from '@/api/MofaService'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
// import { validationMixin } from 'vuelidate'
// import { required, minLength, numeric, alpha, alphaNum } from 'vuelidate/lib/validators'
import * as utils from '@/mixins/utils'
import toast from '@/mixins/toast'
import mofaMixin from '@/mixins/validators/LandMofa-validators'

export default {  
  components: {
    FileUpload
  },
  data () {
    return {
      agencyId: 0,
      agencyName: null,
      travelDate: null,
      requestTypeId: 0,
      vehicleType: null,
      route: null,
      cargoDetails: null,
      cargoType: null,
      distributionPlan: null,
      primaryBeneficiaries: null,
      beneficiaries: null,
      modified: {
        notification: false,
        mofa: false
      },
      local: constants.DATE_LOCALE_EN     
    }
  },
  mixins: [
    mofaMixin    
  ],    
  computed: {
    ...mapGetters({
      agencyList: types.GET_AGENCIES,
      notificationId: types.GET_NOTIFICATION_ID,     
      mode: types.GET_MODE,
      mofa: types.GET_MOFA_NSL
    }),
    getAgencyName: function () {
      return (id) => {
        for(var obj of this.agencyList) {
          if(obj.id === id) {
            return obj.name
          }
        }
      }
    }   
  },
  methods: {

    initModal() {
      this.agencyName = null
      this.validation.reset()
      this.$refs.agencyName.focus()

    },
    cancelAgencyEventHandler () {
      this.$refs.agencyModal.hide()
    },

    showOtherField (e) {
      this.isOtherOrgnization = (e === 1) ? true : false
    },
    saveAgencyEventHandler (e) {
       const $this = this       
       this.$validate()
          .then(function (success) {            
            if (success) {
                $this.$store.dispatch(types.ACTION_ADD_AGENCY, {name: $this.agencyName} )
                toast.success( $this.agencyName + " is now added in the agency list.")
                $this.$refs.agencyModal.hide()
            }
      })
    },
    saveMofaEventHandler () {

    },
    async saveMofa () {
      let payload =  this.$store.state.mofa.mofa
      console.log(this.$store.state.mofa)

      payload.start_date = new Date(this.getDate(this.start_date))
      payload.end_date = new Date(this.getDate(this.end_date))

      console.log("**********************")
      console.log(payload.start_date)
      console.log(payload.end_date)
      console.log("**********************")

      if (this.mofa.origin_departure_time) {
        payload.origin_arrival_time = this.getDate(this.mofa.origin_arrival_time)
        payload.origin_departure_time = this.getDate(this.mofa.origin_departure_time)
        payload.destination_arrival_time = this.getDate(this.mofa.destination_arrival_time)
        payload.destination_departure_time = this.getDate(this.mofa.destination_departure_time)
      }

      payload.agency_id =  this.agency_id
      payload.notification_id = this.$store.state.notificationId

      // payload.registration_no= string
      // payload.land_carrier= string 
      // payload.land_carrier_type= string 
      // payload.mission_route_from= string 
      // payload.mission_route_to= string 
      // payload.mission_route_others= string 
      // payload.cargo_details= string 
      // payload.no_intl_employees= integer 
      // payload.no_natl_employees= integer 
      // payload.quantity= integer 
      // payload.weight= integer 
      // payload.cost= integer 
      // payload.benefit_gov_district= string 
      // payload.first_beneficiary= string 
      // payload.other_beneficiary= string 
      // payload.icao= string 
      // payload.mission_no= string 
      // payload.landing_no= string 
      // payload.leasing_company= string 
      // payload.plane_type= string 
      // payload.ship_name= string 
      // payload.call_sign= string 
      // payload.registration_port= string 
      // payload.ship_flag= string 

      //console.log(JSON.stringify(payload))
      

      if (this.mode === constants.MODE_EDIT) {
        const notificationId = this.$store.state.notificationId
        const mofaId = this.$store.state.mofa.id
        let ctr = 0

        if (this.modified.mofa) {
          //this.updateMofa(notificationId)
          toast.success( "Saved successfully")
          this.disableSaveButton = true
        }
        // this.$store.dispatch(types.ACTION_UPDATE_MOFA, payload)
      }
      else if (this.mode === constants.MODE_NEW) { 
        // console.log('****** Add mode ******')
        // console.log(JSON.stringify( this.form))
        // console.log('****** PAYLOAD ******')
        // console.log(JSON.stringify(payload))
        // this.$store.dispatch(types.ACTION_ADD_MOFA, payload)
        toast.success( "Saved successfully")
        this.disableSaveButton = true
      }

    },          
    attachEventHandler(files) {
      if (!files.length) return
      let formData = new FormData();  
      Array.from(Array(files.length).keys())
           .map(i => {
              alert(files[i].name)
              formData.append('file', files[i], files[i].name);
          });
    },
    getFormVals () {
      // this.$store.commit(types.MUTATE_MOFA, this.form)
      this.saveMofa()
    },    
    submitModals (type) {
     if (type === 'uploadPhotos') {
        let fTemp = []
      }
      // close popup
      this.disableSaveButton = false
      this.close(type)
    },
    closeEventHandler () {
      this.$store.commit(types.MUTATE_RESET_STATE)
      if (this.$store.state.permission === constants.ADMIN) {
          this.$router.replace('/dashboard')
      }    
      else {
          this.$router.replace('/user-dashboard')
      }  
    }
  },
  created() {
      this.$store.dispatch(types.ACTION_FIND_AGENCIES)
      this.$store.dispatch(types.ACTION_FIND_REQUEST_TYPES)
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,  
.fade-leave-to {
  opacity: 0;
}
/*h5 {
  color: #373767;
}
*/
#mofa {
  direction: rtl;
}
/*#mofa .row {
  border-bottom: #c8ced3 solid 1px;
  padding: 10px;
}
*/
.form-group.required label::after {
   margin-right: 4px;
   content:"*";
   color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/NSL-Mofa.vue